<template>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>
          <span>Urgent Shift</span>
       
      </ion-title>
      <ion-buttons slot="end">
        <ion-button @click="share()">
          <i class="el-icon-share"></i>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <div v-if="shifts.length === 0" class="search_jobs_header-outer">
       
       <div class="search_jobs_header search_jobs_header--custom">

        <div class="search_jobs_header-top">
          <img :src="require(`@/assets/img/illustrations/unavailable.svg`)" alt=""  class="urgent-taken"/>
          <div class="main_title text-center"><i class="el-icon-warning"></i> Shift has been taken!</div>
        </div>
      
         <el-button class="w100" :type="'blue'" @click="close()">
           Click here to browse more shifts
         </el-button>
       </div>
     </div>
      <div v-else class="main_wrapper ion-padding">
        <div class="container">
          <el-alert
            v-if="job.pending_documents"
            title="Acknowledgment pending — complete required onboarding documents before accepting shifts"
            type="warning"
            :closable="false"
            show-icon
            class="mb-3"
          ></el-alert>
          <div class="job_info_wrapper" v-if="job.pharmacy">
            <div class="image_text_comp d-block" @click="userInfoModalOpen()">
              <div class="image_wrapper">
                <el-avatar
                  :size="'medium'"
                  shape="square"
                  :src="job.pharmacy.image"
                  v-if="job.pharmacy.image"
                />
                <el-avatar
                  :size="'small'"
                  shape="square"
                  icon="el-icon-user-solid"
                  v-else
                ></el-avatar>
              </div>
              <div class="text_wrapper mt-2">
                <div class="main_text">{{ job.pharmacy.name }}</div>
                <div class="additional_text">
                  <span class="distance">
                    <span class="locumate_icons locumate_icon-cursor"></span>
                    <span v-if="job.distance">{{ job.distance }} km</span>
                    <span class="symb_infinity" v-else></span>
                    <span class="symb_dot"></span>
                  </span>
      
                  <span>{{ $filters.addressText(job.pharmacy.address) }}</span>
                </div>
              </div>
            </div>
            <div class="info-separator"></div>
            <div class="rate_shifts_info">
              <div class="info_wrapper d-flex align-items-center gap-2">
                <DollarWithCircleIcon />
                <div class="info_title">Hourly rate (excluding super)</div>
                <div class="info_value">
                  {{
                    formatHourlyRate(job.recommendedRate, job.recommendedWeekendRate)
                  }}
                </div>
              </div>
              <!-- <div class="info_wrapper">
                <div class="info_title">Available shifts</div>
                <div class="info_value">
                  <template v-if="checkJobDateStart(job.startDate, job.endDate)">
                    <span>{{ checkJobDateStart(job.startDate, job.endDate) }}</span> -
                  </template>
                  <span>{{
                    $moment(job.endDate, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("D MMMM")
                  }}</span>
                </div>
              </div> -->
            </div>
            <div class="info-separator mb-0"></div>
            <el-collapse accordion class="job-about-collapse" @change="handleChange">
              <el-collapse-item
                class="card-accordeon"
                title="More about the job"
                name="first"
              >
                <div class="collapse-list more-info">
                  <div class="collapse-item">
                    <span class="collapse-title">Hourly Rate (excluding super)</span>
                    <span class="collapse-value">
                      {{
                        formatHourlyRate(
                          job.recommendedRate,
                          job.recommendedWeekendRate
                        )
                      }}</span
                    >
                  </div>
                  <div v-if="job.settings.language" class="collapse-item">
                    <span class="collapse-title">Language</span>
                    <span class="collapse-value">{{ job.settings.language }}</span>
                  </div>
      
                  <div class="collapse-item">
                    <span class="collapse-title">Solo Pharmacist</span>
                    <span class="collapse-value">{{
                      job.settings.solo == 1 ? "Yes" : "No"
                    }}</span>
                  </div>
      
                  <div class="collapse-item">
                    <span class="collapse-title"> "Covid" {{ message.Immuniser }} req?</span>
                    <span class="collapse-value">{{
                      job.covidCertRequired == 0
                        ? "Not Required"
                        : job.covidCertRequired == 1
                        ? "Mandatory"
                        : "Nice to Have"
                    }}</span>
                  </div>
      
                  <div class="collapse-item">
                    <span class="collapse-title">Number of technicians</span>
                    <span class="collapse-value">{{ job.settings.numOfTech }}</span>
                  </div>
      
                  <div class="collapse-item" v-if="job.settings.payingForTravel == 3 && job.maxTravelCompensation !== 0">
                    <span class="collapse-title">Pay for Travel</span>
                    <span class="collapse-value">Capped Travel</span>
                  </div>
                  <div class="collapse-item" v-else>
                    <span class="collapse-title">Pay for Travel {{
                      job.settings.payingForTravel == 1 ? " (>50KM roundtrip)" : ""
                    }}</span>
                    <span class="collapse-value">{{
                      job.settings.payingForTravel == 0
                      ? "No travel"
                      : job.settings.payingForTravel == 1
                        ? "Partial travel"
                        : "Full travel"
                    }}</span>
                  </div>
                  <div class="collapse-item">
                    <span class="collapse-title">Pay for Flights</span>
                    <span class="collapse-value">{{
                      job.settings.payForFlights == 0 ? "No" : "Yes"
                    }}</span>
                  </div>
                  <div class="collapse-item">
                    <span class="collapse-title">Pay for Accommodation</span>
                    <span class="collapse-value">{{
                      job.settings.payForAccommodation == 0 ? "No" : "Yes"
                    }}</span>
                  </div>
                  <div class="collapse-item" v-if="isAustralia">
                    <span class="collapse-title">Dosage Administration Aids</span>
                    <span class="collapse-value">{{
                      job.settings.adminAids == 1 ? "Yes" : "No"
                    }}</span>
                  </div>
                  <div class="collapse-item">
                    <span class="collapse-title">Open Pharmacy</span>
                    <span class="collapse-value">{{
                      job.settings.openUp == 1 ? "Yes" : "No"
                    }}</span>
                  </div>
                  <div class="collapse-item">
                    <span class="collapse-title">Close Pharmacy</span>
                    <span class="collapse-value">{{
                      job.settings.close == 1 ? "Yes" : "No"
                    }}</span>
                  </div>
                  <div v-if="job.settings.notes" class="collapse-item collapse-item--notes">
                    <span class="collapse-title">Notes</span>
                    <p class="job-notes__content">{{ job.settings.notes }}</p>
                  </div>
                  <div v-if="job.settings.parking" class="collapse-item collapse-item--notes">
                    <span class="collapse-title">Parking</span>
                    <p class="job-notes__content">{{ job.settings.parking }}</p>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
            <div class="info-separator mt-0"></div>
          </div>
      
          <div>
            <el-form
            class="job_shifts_wrapper full_page"
            :model="formsData.dayForm"
            :rules="formsData.dayForm.rules"
            :ref="(el) => (formsData.dayForm.ref = el)"
            :label-position="'top'"
            @submit.prevent="submit('dayForm')"
          >
            <div
              class="form_text"
              v-if="formsData.dayForm.jobShifts.value.length >= 2"
            >
              <div class="text_note">Deselect days you do not wish to work</div>
            </div>
            <div
              class="job_shifts_form_checkbox"
              v-for="(shift, i) in formsData.dayForm.jobShifts.value"
              :key="shift.date"
            >
           
            <div v-if="shift.disabled==true">
                
                <i class="el-icon-warning"></i>Conflict with shift
            </div>
              <el-form-item class="mb0" prop="jobShifts">
                <el-checkbox
                  :disabled="shift.disabled"
                  class="checkbox_w100"
                  v-model="shift.checkboxValue"
                  @change="checkboxValueChange"
                >
                  <div
                    :class="shift.confirmedHours ? 'confirmedHours' : ''"
                    class="job_shift_text"
                  >
                    <div class="day_info">
                      <div class="day_name">
                        {{ $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("ddd") }},
                        {{ $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("D MMM, YYYY") }}
                      </div>
                      <div class="day_time">
                        <span>{{
                          $moment(shift.startTime, "HH:mm").format("h:mm A")
                        }}</span>
                        -
                        <span>{{
                          $moment(shift.endTime, "HH:mm").format("h:mm A")
                        }}</span>
                      </div>
                    </div>
                    <div class="info-wrapper">
                      <div class="day_info_block">
                        <DollarWithCircleIcon />
                        <div class="day_name">Rate</div>
                        <div class="day_time">
                          <span v-if="showShiftInformation(shift)">
                            {{ Rate(shift) }}</span
                          >
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div class="day_info_block">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.3333 10C18.3333 14.6 14.6 18.3333 10 18.3333C5.4 18.3333 1.66667 14.6 1.66667 10C1.66667 5.40001 5.4 1.66667 10 1.66667C14.6 1.66667 18.3333 5.40001 18.3333 10Z"
                            stroke="rgb(var(--locumate-primary-color-dark))"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M13.0917 12.65L10.5083 11.1083C10.0583 10.8417 9.69167 10.2 9.69167 9.675V6.25833"
                            stroke="rgb(var(--locumate-primary-color-dark))"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <div class="day_name">Hours</div>
                        <div class="day_time">
                          <span v-if="showShiftInformation(shift)">
                            {{
                              confirmedHours(
                                shift.confirmedHours,
                                shift.startTime,
                                shift.endTime
                              )
                            }}</span
                          >
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div class="day_info_block">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.72501 3.83334C2.39167 0.950004 6.73334 0.950004 7.39167 3.83334C7.78334 5.525 6.70834 6.95834 5.77501 7.85C5.09167 8.5 4.01667 8.49167 3.33334 7.85C2.40834 6.95834 1.33334 5.525 1.72501 3.83334Z"
                            stroke="rgb(var(--locumate-primary-color-dark))"
                            stroke-width="1.5"
                          />
                          <path
                            d="M12.5583 13.8333C13.225 10.95 17.5917 10.95 18.2583 13.8333C18.65 15.525 17.575 16.9583 16.6333 17.85C15.95 18.5 14.8667 18.4917 14.1833 17.85C13.2417 16.9583 12.1667 15.525 12.5583 13.8333Z"
                            stroke="rgb(var(--locumate-primary-color-dark))"
                            stroke-width="1.5"
                          />
                          <path
                            d="M9.99997 4.16699H12.2333C13.775 4.16699 14.4916 6.07533 13.3333 7.09199L6.67497 12.917C5.51664 13.9253 6.23331 15.8337 7.76664 15.8337H9.99997"
                            stroke="rgb(var(--locumate-primary-color-dark))"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4.57185 4.58366H4.58148"
                            stroke="rgb(var(--locumate-primary-color-dark))"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M15.4052 14.5837H15.4148"
                            stroke="rgb(var(--locumate-primary-color-dark))"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <div class="day_name">Travel</div>
                        <div class="day_time">
                          <span v-if="showShiftInformation(shift)">
                            {{ travelCompensationCount(job, shift) }}
                          </span>
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div class="day_info_block">
                        <DollarWithCircleIcon />
                        <div class="day_name">Sum</div>
                        <div class="day_time">
                          <span v-if="showShiftInformation(shift)">
                            {{ Sum(shift) }}</span
                          >
                          <span v-else>-</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-checkbox>
                <template #error="{ error }">
                  <div
                    class="error_list"
                    v-if="
                      error ||
                      (formsData.dayForm.jobShifts.errors &&
                        formsData.dayForm.jobShifts.errors[i])
                    "
                  >
                    <div
                      class="el-form-item__error"
                      :class="
                        formsData.dayForm.jobShifts.errors &&
                        formsData.dayForm.jobShifts.errors[i]
                          ? ''
                          : 'form_error'
                      "
                    >
                      <span
                        v-if="
                          error &&
                          !formsData.dayForm.jobShifts.errors &&
                          formsData.dayForm.jobShifts.value.length - 1 == i
                        "
                        >{{ error }}</span
                      >
                      <span
                        v-if="
                          formsData.dayForm.jobShifts.errors &&
                          formsData.dayForm.jobShifts.errors[i]
                        "
                        >{{ formsData.dayForm.jobShifts.errors[i].message }}</span
                      >
                    </div>
                  </div>
                  <span v-else></span>
                </template>
              </el-form-item>
            </div>
            <el-form-item prop="jobShiftsErrors" class="button_submit mb0">
              <el-button class="submit_page" type="grey" @click="goNext('dayForm')">
                Calendar View              </el-button>
              <!-- Pending documents checklist on main page if pending documents exist -->
              <div class="pending-documents-card mb-3" v-if="pendingDocumentList && pendingDocumentList.length > 0">
                <div class="pending-documents-header">
                  <div class="pending-documents-title">
                    <i class="el-icon-document-checked mr-1"></i> Required Onboarding Documents
                  </div>
                  <div class="pending-documents-subtitle">
                    Please click each document to review and acknowledge before proceeding.
                  </div>
                </div>
                <div class="pending-documents-list">
                  <div 
                    v-for="(doc, index) in pendingDocumentList" 
                    :key="doc.id || index"
                    class="pending-doc-item"
                    :class="{ 'is-acknowledged': doc.acknowledged, 'is-required': doc.required }"
                    @click="handleDocItemClick(doc)"
                  >
                    <div class="pending-doc-checkbox-wrapper">
                      <el-checkbox 
                        :model-value="doc.acknowledged" 
                        :disabled="doc.acknowledged"
                        @change="handleDocItemClick(doc)"
                        @click.stop
                      ></el-checkbox>
                    </div>
                    <div class="pending-doc-info">
                      <div class="pending-doc-name-row">
                        <span class="pending-doc-name">{{ doc.name }}</span>
                        <span v-if="doc.required" class="doc-badge-required">Required</span>
                        <span v-if="doc.acknowledged" class="doc-badge-accepted">
                          <i class="el-icon-check"></i> Accepted
                        </span>
                      </div>
                      <div class="pending-doc-action-row">
                        <span class="doc-action-hint" v-if="!doc.acknowledged">
                          <i class="el-icon-edit-outline"></i> Click to review & accept
                        </span>
                        <a 
                          v-if="doc.url" 
                          :href="doc.url" 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          class="doc-preview-link"
                          @click.stop
                        >
                          <i class="el-icon-view"></i> View Document <i class="el-icon-top-right"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

               <el-button
                class="submit_page"
                type="blue"
                @click="dialogVisible = true"
                :disabled="formsData.dayForm.disabled || !areAllRequiredDocsAccepted"
                v-if="job.applyJob"
              >
                Apply now
              </el-button>
              <el-button
                class="submit_page"
                type="blue"
                @click="dialogVisible = true"
                :disabled="formsData.dayForm.disabled || !areAllRequiredDocsAccepted" v-else
              >
                Accept
              </el-button>
            </el-form-item>
          </el-form>
          </div>
        </div>
      
    <div class="el_dialog_wraper">
      <el-drawer
        v-model="dialogVisible"
        custom-class="bottom_drop_up accept_shift"
        title="Please ensure you have checked your availability for selected shift(s). Any cancellations will impact your reliability rating on the platform. "
        width="30%"
        :append-to-body="true" :with-header="false" :direction="'btt'" :destroy-on-close="true" data-testid="more-bottom-drop-up-drawer"
      >
        <div class="title-wrapper text-center">
          <div class="title text-locumate-secondary">Are you sure!</div>
          <p class="message">
            Please ensure you have checked your availability for selected shift(s). Any cancellations will impact your reliability rating on the platform.  
          </p>
        </div>
        <div
          class="job_shifts_form_checkbox"
          v-for="shift in formsData.dayForm.jobShifts.value"
          :key="shift.date"
        >
          <div
            class="job_shifts_wrapper full_page"
            v-if="shift.checkboxValue == true"
          >
            <div class="mb0 shift-check" prop="jobShifts">
              <div
                :class="shift.confirmedHours ? 'confirmedHours' : ''"
                class="job_shift_text"
              >
              <div class="check-icon"><i class="el-icon-check"></i></div>
                <div class="">
                  <div class="check-outer">
                    <!-- <span><i class="el-icon-check"></i></span> -->
                    <div class="check-inner day_info">
                      <div class="day_name day_name-bold">
                        {{ $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("ddd") }},
                        {{
                          $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("D MMM, YYYY")
                        }}
                      </div>
                      <div class="day_time">
                        <span>{{
                          $moment(shift.startTime, "HH:mm").format("h:mm A")
                        }}</span>
                        -
                        <span>{{
                          $moment(shift.endTime, "HH:mm").format("h:mm A")
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="info-wrapper">
                  <div class="day_info_block">
                    <DollarWithCircleIcon />
                    <div class="day_name day_name-bold">Hourly Rate</div>
                    <div class="day_time">
                      <span v-if="showShiftInformation(shift)">
                        {{ Rate(shift) }}</span
                      >
                      <span v-else>-</span>
                    </div>
                  </div>
                  <div class="day_info_block">
                    <RoutingIcon />
                    <div class="title" v-if="job.settings.payingForTravel == 3 && job.maxTravelCompensation !== 0">
                      <span>{{ job.enableTravelAllowanceForFirstAndLastDay === 1 ? "Travel" : "Capped Travel" }}</span>
                    </div>
                    <div class="title" v-else>
                      <span>Travel</span>
                    </div>
                    <div class="day_time">
                      <span v-if="showShiftInformation(shift)">
                        {{ travelCompensationCount(job, shift) }}</span
                      >
                      <span v-else>-</span>
                    </div>
                  </div>
                  <div class="day_info_block">
                    <DollarWithCircleIcon />
                    <div class="day_name day_name-bold">Sum</div>
                    <div class="day_time">
                      <span v-if="showShiftInformation(shift)">
                        {{ Sum(shift) }}</span
                      >
                      <span v-else>-</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Pending documents inline banner -->
        <transition name="pending-banner-fade">
          <div v-if="pendingDocumentBanner" :class="pendingDocumentBannerSuccess ? 'premium-success-banner' : 'premium-error-banner'">
            <span class="premium-banner__icon">
              <!-- Red error icon if success is false -->
              <svg v-if="!pendingDocumentBannerSuccess" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clip-rule="evenodd" />
              </svg>
              <!-- Green check circle icon if success is true -->
              <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.736-5.23z" clip-rule="evenodd" />
              </svg>
            </span>
            <span class="premium-banner__text">{{ pendingDocumentBannerMessage }}</span>
          </div>
        </transition>

        <!-- Pending documents checklist in confirmation drawer -->
        <div class="pending-documents-card" v-if="pendingDocumentList && pendingDocumentList.length > 0">
          <div class="pending-documents-header">
            <div class="pending-documents-title">
              <i class="el-icon-document-checked mr-1"></i> Required Onboarding Documents
            </div>
            <div class="pending-documents-subtitle">
              Please click each document to review and acknowledge before proceeding.
            </div>
          </div>

          <div class="pending-documents-list">
            <div 
              v-for="(doc, index) in pendingDocumentList" 
              :key="doc.id || index"
              class="pending-doc-item"
              :class="{ 'is-acknowledged': doc.acknowledged, 'is-required': doc.required }"
              @click="handleDocItemClick(doc)"
            >
              <div class="pending-doc-checkbox-wrapper">
                <el-checkbox 
                  :model-value="doc.acknowledged" 
                  :disabled="doc.acknowledged"
                  @change="handleDocItemClick(doc)"
                  @click.stop
                ></el-checkbox>
              </div>
              <div class="pending-doc-info">
                <div class="pending-doc-name-row">
                  <span class="pending-doc-name">{{ doc.name }}</span>
                  <span v-if="doc.required" class="doc-badge-required">Required</span>
                  <span v-if="doc.acknowledged" class="doc-badge-accepted">
                    <i class="el-icon-check"></i> Accepted
                  </span>
                </div>
                <div class="pending-doc-action-row">
                  <span class="doc-action-hint" v-if="!doc.acknowledged">
                    <i class="el-icon-edit-outline"></i> Click to review & accept
                  </span>
                  <a 
                    v-if="doc.url" 
                    :href="doc.url" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    class="doc-preview-link"
                    @click.stop
                  >
                    <i class="el-icon-view"></i> View Document <i class="el-icon-top-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="dialog-footer accept-shift-actions-row">
            <el-button
              class="submit_page btn-half"
              type="blue"
              :disabled="formsData.dayForm.disabled || !areAllRequiredDocsAccepted"
              v-if="job.applyJob"
              @click="applyShift('dayForm', job.id)"
            >
              Apply now
            </el-button>
            <el-button
              class="submit_page btn-half"
              type="blue"
              @click="submit('dayForm')"
              :disabled="formsData.dayForm.disabled || !areAllRequiredDocsAccepted"
              v-else
            >
              Accept shift(s)
            </el-button>
            
          <el-button class="btn-half btn-cancel el-button--grey" :type="gray" @click="dialogVisible = false">Cancel</el-button>
        </div>
      </el-drawer>
    </div>
     </div>
   
    <modal-user-info
      :modalName="'userInfoModal'"
      :options="userInfoModal"
    ></modal-user-info>

    <!-- Document Review and Acknowledge Dialog Modal -->
    <el-dialog
      v-model="showDocReviewModal"
      :title="'Review & Acknowledge Document'"
      custom-class="doc-review-dialog"
      width="90%"
      :append-to-body="true"
      :close-on-click-modal="false"
      center
    >
      <div class="doc-modal-content" v-if="selectedDocForReview">
        <div class="doc-modal-header-section">
          <div class="doc-modal-title-row">
            <h3 class="doc-modal-doc-title">
              <i class="el-icon-document mr-1"></i> {{ selectedDocForReview.name }}
            </h3>
            <span v-if="selectedDocForReview.required" class="doc-badge-required">Required</span>
            <span v-if="selectedDocForReview.acknowledged" class="doc-badge-accepted">
              <i class="el-icon-check"></i> Accepted
            </span>
          </div>

          <div class="doc-modal-actions-toolbar" v-if="selectedDocForReview.url">
            <a 
              :href="selectedDocForReview.url" 
              target="_blank" 
              rel="noopener noreferrer" 
              class="btn-modal-action btn-open"
            >
              <i class="el-icon-top-right"></i> Open in New Tab
            </a>
            <button 
              type="button" 
              class="btn-modal-action btn-download"
              :disabled="isDownloadingDoc"
              @click="downloadDoc(selectedDocForReview)"
            >
              <i :class="isDownloadingDoc ? 'el-icon-loading' : 'el-icon-download'"></i>
              {{ isDownloadingDoc ? 'Downloading...' : 'Download Document' }}
            </button>
          </div>
        </div>

        <!-- Inline Document Preview Box -->
        <div class="doc-inline-preview-wrapper" v-if="selectedDocForReview.url">
          <!-- Image Preview -->
          <div v-if="isImageDoc(selectedDocForReview.url)" class="doc-preview-container doc-preview-image-box">
            <img 
              :src="selectedDocForReview.url" 
              :alt="selectedDocForReview.name" 
              class="doc-preview-image" 
            />
          </div>

          <!-- PDF / Frame Preview -->
          <div v-else-if="isPdfDoc(selectedDocForReview.url)" class="doc-preview-container doc-preview-frame-box">
            <iframe 
              :src="selectedDocForReview.url" 
              class="doc-preview-iframe"
              frameborder="0"
            ></iframe>
          </div>

          <!-- Other File Types Preview -->
          <div v-else class="doc-preview-container doc-preview-frame-box">
            <iframe 
              :src="selectedDocForReview.url" 
              class="doc-preview-iframe"
              frameborder="0"
            ></iframe>
          </div>
        </div>

        <div class="doc-modal-acknowledgement-box">
          <div class="ack-note">
            <i class="el-icon-info mr-1"></i> By clicking <strong>"I Accept & Acknowledge"</strong>, you confirm that you have read, reviewed, and agreed to the contents of this document.
          </div>
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer flex-footer">
          <el-button @click="showDocReviewModal = false" class="el-button--grey">Cancel</el-button>
          <el-button 
            type="primary" 
            class="el-button--blue"
            :loading="isAcknowledgingDoc"
            :disabled="selectedDocForReview && selectedDocForReview.acknowledged"
            @click="confirmAcknowledgeDoc"
          >
            {{ (selectedDocForReview && selectedDocForReview.acknowledged) ? 'Already Accepted' : 'I Accept & Acknowledge' }}
          </el-button>
        </div>
      </template>
    </el-dialog>
  </template>
  
  <script>
  import { ElMessage } from "@/components/Vendor/Element";
  
  import moment from "moment";
  
  import { ref, onBeforeMount, onMounted, inject, nextTick, computed } from "vue";
  
  import { addIcons } from "ionicons";
  import { arrowBackOutline } from "ionicons/icons";
  
  addIcons({
    "arrow-back-outline": arrowBackOutline,
  });
  import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,
  } from "@ionic/vue";
  
  import { useStore } from "vuex";
  import { useRoute, useRouter } from "vue-router";
  import formHooks from "@/hooks/form/form";
  import formValidate from "@/hooks/form/validate/validate";
  
  import { UserInfoModal } from "@/modals/modals";
  import timeDiff from "@/helpers/date/timeDiff";
  import timeDiffAsDecimal from "@/helpers/date/timeDiffAsDecimal";
  import { ElMessageBox } from "@/components/Vendor/Element";
  import store from "@/store/store";
  import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
import DollarWithCircleIcon from "@/components/Icons/DollarWithCircleIcon.vue";
import RoutingIcon from "@/components/Icons/RoutingIcon.vue";

  export default {
    components: {
      IonToolbar,
      IonButton,
      IonButtons,
      IonIcon,
      IonTitle,
      "modal-user-info": UserInfoModal,
      DollarWithCircleIcon,
      RoutingIcon,
    },
    directives: {},
    
    setup() {
      const $store = useStore();
      const $router = useRouter();
      const route = useRoute();
      const dialogVisible = ref(false);
      const pendingDocumentBanner = ref(false);
      let pendingDocumentBannerTimer = null;
      const pendingDocumentBannerSuccess = ref(false);
      const pendingDocumentBannerMessage = ref("");
      const pendingDocumentList = ref([]);
      const showDocReviewModal = ref(false);
      const selectedDocForReview = ref(null);
      const isAcknowledgingDoc = ref(false);
      const assignAcceptanceTrackingId = ref(null);

      const extractRawDocs = (data) => {
        if (!data) return [];
        if (data.documents && (Array.isArray(data.documents) || typeof data.documents === "object")) {
          return data.documents;
        }
        if (data.document && (Array.isArray(data.document) || typeof data.document === "object")) {
          return data.document;
        }
        if (data.pendingDocuments && (Array.isArray(data.pendingDocuments) || typeof data.pendingDocuments === "object")) {
          return data.pendingDocuments;
        }
        if (data.pending_documents && (Array.isArray(data.pending_documents) || typeof data.pending_documents === "object")) {
          return data.pending_documents;
        }
        return [];
      };

      const extractAcceptanceTrackingId = (data) => {
        if (!data) return null;
        if (typeof data !== "object") return null;

        if (data.acceptance_tracking_id) return data.acceptance_tracking_id;
        if (data.acceptanceTrackingId) return data.acceptanceTrackingId;
        if (data.acceptance_tracking?.id) return data.acceptance_tracking.id;
        if (data.tracking_id) return data.tracking_id;
        if (data.trackingId) return data.trackingId;
        if (data.acceptance_id) return data.acceptance_id;
        if (data.acceptanceId) return data.acceptanceId;

        if (data.data && typeof data.data === "object") {
          const nested = extractAcceptanceTrackingId(data.data);
          if (nested) return nested;
        }

        if (data.response && typeof data.response === "object") {
          const nestedResp = extractAcceptanceTrackingId(data.response.data || data.response);
          if (nestedResp) return nestedResp;
        }

        const docs = extractRawDocs(data);
        if (Array.isArray(docs) && docs.length > 0) {
          for (const doc of docs) {
            if (doc && typeof doc === "object") {
              const docTrackingId =
                doc.acceptance_tracking_id ||
                doc.acceptanceTrackingId ||
                doc.acceptance_tracking?.id ||
                doc.tracking_id ||
                doc.trackingId ||
                doc.acceptance_id ||
                doc.acceptanceId;
              if (docTrackingId) return docTrackingId;
            }
          }
        }

        return null;
      };

      const hasPendingDocs = (data) => {
        if (!data) return false;
        if (data.pending_documents === true || data.pendingDocuments === true) return true;
        const docs = extractRawDocs(data);
        return Array.isArray(docs) ? docs.length > 0 : Object.keys(docs).length > 0;
      };

      const normalizeDocuments = (rawDocs, parentData = null) => {
        if (!rawDocs) return [];
        let list = [];
        if (Array.isArray(rawDocs)) {
          list = rawDocs;
        } else if (typeof rawDocs === "object") {
          list = Object.values(rawDocs);
        }
        const parentTrackingId = extractAcceptanceTrackingId(parentData) || assignAcceptanceTrackingId.value || null;
        return list.map((doc, idx) => {
          const docObj = (doc && typeof doc === "object") ? doc : {};
          const docTrackingId =
            docObj.acceptance_tracking_id ||
            docObj.acceptanceTrackingId ||
            docObj.acceptance_tracking?.id ||
            docObj.tracking_id ||
            docObj.trackingId ||
            docObj.acceptance_id ||
            docObj.acceptanceId ||
            parentTrackingId ||
            assignAcceptanceTrackingId.value ||
            null;

          return {
            id: docObj.document_id || docObj.documentId || docObj.id || `doc_${idx}`,
            document_id: docObj.document_id || docObj.documentId || docObj.id || `doc_${idx}`,
            name: docObj.name || docObj.title || "Onboarding Document",
            required: docObj.required === true || docObj.required === 1 || docObj.required === "1" || docObj.required === "true",
            url: docObj.url || docObj.document_url || docObj.link || "",
            shiftId: docObj.shiftId || docObj.shift_id || null,
            shift_id: docObj.shiftId || docObj.shift_id || null,
            group_user_id: docObj.group_user_id || docObj.group_manager_id || null,
            acceptance_tracking_id: docTrackingId,
            acknowledged: !!docObj.acknowledged || !!docObj.accepted || false,
            ...docObj,
          };
        });
      };

      const areAllRequiredDocsAccepted = computed(() => {
        if (!pendingDocumentList.value || pendingDocumentList.value.length === 0) {
          return true;
        }
        return pendingDocumentList.value
          .filter((doc) => doc.required)
          .every((doc) => doc.acknowledged);
      });

      const handleDocItemClick = (doc) => {
        selectedDocForReview.value = doc;
        showDocReviewModal.value = true;
      };

      const confirmAcknowledgeDoc = async () => {
        if (!selectedDocForReview.value) return;
        try {
          isAcknowledgingDoc.value = true;
          const shiftIds = Array.isArray(selectedDocForReview.value.shiftId)
            ? selectedDocForReview.value.shiftId
            : [selectedDocForReview.value.shiftId || selectedDocForReview.value.shift_id || getSelectedShiftsId()[0]];

          const trackingId =
            selectedDocForReview.value.acceptance_tracking_id ||
            selectedDocForReview.value.acceptanceTrackingId ||
            selectedDocForReview.value.tracking_id ||
            assignAcceptanceTrackingId.value ||
            null;

          const payload = {
            document_id: selectedDocForReview.value.document_id || selectedDocForReview.value.id,
            shift_id: shiftIds[0] || null,
            shift_ids: shiftIds,
            status: "accepted",
          };

          if (trackingId) {
            payload.acceptance_tracking_id = trackingId;
          }

          const groupUserId =
            selectedDocForReview.value.group_user_id ||
            selectedDocForReview.value.group_manager_id;
          if (groupUserId) {
            payload.group_user_id = groupUserId;
          }

          const invId =
            selectedDocForReview.value.invitation_id ||
            selectedDocForReview.value.invitationId ||
            selectedDocForReview.value.internal_pool_invitation_id;
          if (invId) {
            payload.invitation_id = invId;
          }

          console.log("Calling LOCUM_ACKNOWLEDGE_ONBOARDING_DOCUMENT with payload:", payload);
          await $store.dispatch("LOCUM_ACKNOWLEDGE_ONBOARDING_DOCUMENT", payload);

          selectedDocForReview.value.acknowledged = true;
          const found = pendingDocumentList.value.find(
            (d) => (d.document_id && d.document_id === selectedDocForReview.value.document_id) || (d.id && d.id === selectedDocForReview.value.id) || d.name === selectedDocForReview.value.name
          );
          if (found) {
            found.acknowledged = true;
          }

          ElMessage({
            type: "success",
            message: `${selectedDocForReview.value.name} acknowledged successfully!`,
          });

          showDocReviewModal.value = false;

          if (areAllRequiredDocsAccepted.value) {
            pendingDocumentBannerSuccess.value = true;
            pendingDocumentBannerMessage.value = "All required documents acknowledged! You can now proceed to accept/apply.";
            pendingDocumentBanner.value = true;
          }
        } catch (err) {
          console.error("Acknowledge document error:", err);
          ElMessage({
            type: "error",
            message: (err && err.message) || "Failed to acknowledge document. Please try again.",
          });
        } finally {
          isAcknowledgingDoc.value = false;
        }
      };

      const isImageDoc = (url) => {
        if (!url) return false;
        const cleanUrl = url.split("?")[0].toLowerCase();
        return /\.(png|jpe?g|gif|webp|svg|bmp)$/i.test(cleanUrl);
      };

      const isPdfDoc = (url) => {
        if (!url) return false;
        const cleanUrl = url.split("?")[0].toLowerCase();
        return /\.pdf$/i.test(cleanUrl);
      };

      const isDownloadingDoc = ref(false);
      const downloadDoc = async (doc) => {
        if (!doc || !doc.url) return;
        try {
          isDownloadingDoc.value = true;

          let extension = "";
          try {
            const path = doc.url.split("?")[0];
            const parts = path.split(".");
            if (parts.length > 1) {
              extension = "." + parts.pop().toLowerCase();
            }
          } catch (e) {
            // ignore
          }

          let filename = doc.name ? doc.name.trim() : "onboarding-document";
          if (extension && !filename.toLowerCase().endsWith(extension)) {
            filename += extension;
          } else if (!extension) {
            if (isPdfDoc(doc.url)) filename += ".pdf";
            else if (isImageDoc(doc.url)) filename += ".png";
          }

          let downloaded = false;

          // Method 1: Fetch API Blob
          try {
            const response = await fetch(doc.url, { mode: "cors" });
            if (response.ok) {
              const blob = await response.blob();
              const blobUrl = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.style.display = "none";
              link.href = blobUrl;
              link.download = filename;
              document.body.appendChild(link);
              link.click();
              setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
              }, 300);
              downloaded = true;
            }
          } catch (fetchErr) {
            console.warn("Fetch blob download failed, trying XHR:", fetchErr);
          }

          // Method 2: XHR Blob
          if (!downloaded) {
            try {
              await new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open("GET", doc.url, true);
                xhr.responseType = "blob";
                xhr.onload = function () {
                  if (this.status === 200 || this.status === 0) {
                    const blobUrl = window.URL.createObjectURL(this.response);
                    const link = document.createElement("a");
                    link.style.display = "none";
                    link.href = blobUrl;
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    setTimeout(() => {
                      document.body.removeChild(link);
                      window.URL.revokeObjectURL(blobUrl);
                      resolve(true);
                    }, 300);
                  } else {
                    reject(new Error("XHR status " + this.status));
                  }
                };
                xhr.onerror = reject;
                xhr.send();
              });
              downloaded = true;
            } catch (xhrErr) {
              console.warn("XHR blob download failed, trying Canvas / Anchor:", xhrErr);
            }
          }

          // Method 3: Canvas for images
          if (!downloaded && isImageDoc(doc.url)) {
            try {
              await new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = "anonymous";
                img.onload = () => {
                  try {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.naturalWidth || img.width;
                    canvas.height = img.naturalHeight || img.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    canvas.toBlob((blob) => {
                      if (blob) {
                        const blobUrl = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.style.display = "none";
                        link.href = blobUrl;
                        link.download = filename;
                        document.body.appendChild(link);
                        link.click();
                        setTimeout(() => {
                          document.body.removeChild(link);
                          window.URL.revokeObjectURL(blobUrl);
                          resolve(true);
                        }, 300);
                      } else {
                        reject(new Error("Canvas blob is null"));
                      }
                    }, "image/png");
                  } catch (err) {
                    reject(err);
                  }
                };
                img.onerror = reject;
                img.src = doc.url;
              });
              downloaded = true;
            } catch (canvasErr) {
              console.warn("Canvas download failed, falling back to anchor:", canvasErr);
            }
          }

          // Method 4: Hidden anchor fallback
          if (!downloaded) {
            const link = document.createElement("a");
            link.style.display = "none";
            link.href = doc.url;
            link.setAttribute("download", filename);
            link.setAttribute("target", "_self");
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
              document.body.removeChild(link);
            }, 300);
          }

          ElMessage({
            type: "success",
            message: `Downloading "${filename}"...`,
          });
        } catch (err) {
          console.error("Download error:", err);
          ElMessage({
            type: "error",
            message: "Could not download document.",
          });
        } finally {
          isDownloadingDoc.value = false;
        }
      };

      const currentUrl = process.env.VUE_APP_CURRENT_URL;
      const isAustralia = isAustraliaRegion();

      const setPageClassGlobal = inject("setPageClassGlobal");
      const $modals = inject("$modals");
      const googleMaps = inject(["googleMaps"])
      const message = inject("messages");
  
      let job = ref({});
      console.log("🚀 ~ job:", job)
      let shifts = ref(job.value?.shifts ? job.value?.shifts : {});
        
      const userData = $store.getters.GET_USER_DATA;
      const userRole = userData.role;
  
      // shifts.value.forEach((shift) => {
      //   moment().diff(
      //     moment(shift.date + " " + shift.startTime, "YYYY/MM/DD HH:mm:ss"),
      //     "minutes"
      //   ) <= 0
      //     ? (shift.disabled = false)
      //     : (() => {
      //         shift.disabled = true;
      //         shift.checkboxValue = false;
      //       })();
  
      //   if (shift.userId) {
      //     shift.disabled = true;
      //     shift.checkboxValue = false;
      //   }
  
      //   if (shift.abilities) {
      //     const isAssignAvailable = shift.abilities["assign"] == true;
  
      //     shift.disabled = isAssignAvailable ? false : true;
      //     shift.checkboxValue = isAssignAvailable ? true : false;
      //   }
  
      //   if (shift.checkboxValue == undefined) {
      //     shift.checkboxValue = true;
      //   }
      // });
  
      const formsDataArray = {
        dayForm: {
          jobShifts: {
            value: shifts.value,
            errors: null,
            validators: [
              {
                validator: (rule, formField, callback) => {
                  let errors = formsData.dayForm.jobShifts.errors;
                  let formName = formField.formName;
  
                  // console.log(errors);
  
                  if (!errors || !errors.length) {
                    setFormValidation(formName, rule.field, true);
                    callback();
                  } else {
                    setFormValidation(formName, rule.field, false);
                    callback(new Error(""));
                  }
                },
              },
              {
                validator: (rule, formField, callback) => {
                  formValidate.validate(
                    rule,
                    formField,
                    "jobShiftsBook",
                    callback,
                    setFormValidation
                  );
                },
              },
            ],
          },
        },
      };
  
      (async () => {
        try {
          if (!job.value.distance) {
            let needToRetrieveDistance = true;
            let jobsDistancesCache = store.getters.getJobDistancesData.length
              ? store.getters.getJobDistancesData
              : []; // data from cache
  
            for (let cacheItem of jobsDistancesCache) {
              if (cacheItem.id == job.value.pharmacyId && cacheItem.cachedAt) {
                //check if distance exists in cache
                console.log("distance item loaded from cache");
                console.log(cacheItem.distance);
  
                needToRetrieveDistance = false;
                job.value.distance = cacheItem.distance;
                break;
              }
            }
  
            if (needToRetrieveDistance) {
              const result = await googleMaps.getDistance(userData.address, [
                job.value.pharmacy.address,
              ]);
  
              let distance = null;
              let jobDistance = result[0].elements[0].distance
                ? result[0].elements[0].distance.text
                : null;
  
              if (jobDistance) {
                jobDistance = jobDistance.replace(",", ".");
                if (new RegExp("(.*)(km|км)$", "gm").test(jobDistance)) {
                  distance = parseFloat(jobDistance);
                } else if (new RegExp("(.*)(m|м)$", "gm").test(jobDistance)) {
                  distance = parseFloat(jobDistance) / 1000;
                } else {
                  console.log("");
                }
              }
              console.log("----- set distance -----");
              console.log(distance);
  
              job.value.distance = distance;
            }
          }
        } catch (error) {
          console.log(error);
        }
      })();
  
      const checkboxValueChange = () => {
        console.log("hello im clicked");
        if (formsData.dayForm.jobShifts.errors) {
          delete formsData.dayForm.jobShifts.errors;
        }
  
        nextTick(() => {
          checkFormValidation("dayForm", true);
        });
      };
  
      const checkJobDateStart = (dateStart, endDate, trim) => {
        let start = moment(dateStart, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]);
        let end = moment(endDate, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]);
        if (start.format("MMMM") == end.format("MMMM")) {
          if (start.format("D") == end.format("D")) {
            return null;
          }
          return start.format("D ");
        } else {
          return start.format("D " + (trim ? "MMM" : "MMMM"));
        }
      };

      const close=()=>{
        $router.push({
                  name: "search",
                });
      }
      const getSelectedShiftsId = () => {
        return shifts.value
          .filter((day) => {
            if (day.checkboxValue == true) {
              return true;
            }
          })
          .map((day) => day.id);
      };
  
      const userInfoModal = ref({
        name: "userInfo",
        user: {},
      });
  
      const userInfoModalOpen = () => {
        userInfoModal.value.user = job.value.pharmacy;
        $modals.open("userInfoModal");
      };
  
      const goBack = () => {
        goToSearch();
      };
  
      const goToSearch = () =>{
        $router.push({ name: "search" });
      }
  
      const goNext = () => {
        $store.dispatch("setJobDetails", {
          job: job.value,
        });
        $router.push({
          name: "job_book_calendar",
        });
      };


        //job shift apply function
    const applyShift = (formName, jobId) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              const res = await $store.dispatch("APPLY_JOB_SHIFTS_LIST", {
                shift_ids: getSelectedShiftsId(),
                job_id: jobId
              });
              console.log("APPLY_JOB_SHIFTS_LIST response:", res);

              const trackingId = extractAcceptanceTrackingId(res);
              if (trackingId) {
                assignAcceptanceTrackingId.value = trackingId;
              }

              if (res && hasPendingDocs(res)) {
                console.log("Onboarding documents are pending. Triggering banner and checklist.", res);
                const rawDocs = extractRawDocs(res);
                pendingDocumentList.value = normalizeDocuments(rawDocs, res);
                pendingDocumentBannerSuccess.value = false;
                pendingDocumentBannerMessage.value = res.message || "You can't accept this shift yet. Required onboarding documents are still pending.";
                pendingDocumentBanner.value = true;
                dialogVisible.value = true;
                if (pendingDocumentBannerTimer) clearTimeout(pendingDocumentBannerTimer);
                pendingDocumentBannerTimer = setTimeout(() => {
                  pendingDocumentBanner.value = false;
                }, 30000);
                return;
              }

              if (res && res.success === false) {
                  ElMessage({ type: "error", message: res.message });
                  return;
              }

              pendingDocumentBannerSuccess.value = true;
              pendingDocumentBannerMessage.value = "Thank you for applying for the Shift. We will notify you when the shift is offered to you";
              pendingDocumentBanner.value = true;
              if (pendingDocumentBannerTimer) clearTimeout(pendingDocumentBannerTimer);
              pendingDocumentBannerTimer = setTimeout(() => {
                pendingDocumentBanner.value = false;
              }, 30000);

              setTimeout(() => {
                $router.push({
                  name: "search",
                });
              }, 2000);
            } catch (error) {
              console.error("APPLY_JOB_SHIFTS_LIST error caught:", error);
              const trackingId = extractAcceptanceTrackingId(error);
              if (trackingId) {
                assignAcceptanceTrackingId.value = trackingId;
              }
              if (error && hasPendingDocs(error)) {
                console.log("Onboarding documents are pending (from catch block). Triggering banner and checklist.", error);
                const rawDocs = extractRawDocs(error);
                pendingDocumentList.value = normalizeDocuments(rawDocs, error);
                pendingDocumentBannerSuccess.value = false;
                pendingDocumentBannerMessage.value = error.message || "You can't accept this shift yet. Required onboarding documents are still pending.";
                pendingDocumentBanner.value = true;
                dialogVisible.value = true;
                if (pendingDocumentBannerTimer) clearTimeout(pendingDocumentBannerTimer);
                pendingDocumentBannerTimer = setTimeout(() => {
                  pendingDocumentBanner.value = false;
                }, 30000);
                return;
              }
              let errorMessage = [];
              shifts.value.filter((shift) => {
                let errorsArray = error && error.errors && error.errors.some((element) => {
                  if (element.id == shift.id) {
                    errorMessage.push({
                      date: shift.date,
                      message: element.message,
                    });
                    return true;
                  }
                });
                if (!errorsArray) errorMessage.push(null);
              });
              console.log(errorMessage);
              formsData.dayForm.jobShifts.errors = errorMessage;
              checkFormValidation("dayForm", true);
            }
          })();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };
  
      const submit = (formName) => {
        formsRefs[formName].value.validate((valid) => {
          console.log("checking validation", valid);
          if (valid) {
            (async () => {
              try {
              const res = await $store.dispatch("SAVE_JOB_SHIFTS_LIST", {
                shifts_ids: getSelectedShiftsId(),
              });
              console.log("SAVE_JOB_SHIFTS_LIST response:", res);

              const trackingId = extractAcceptanceTrackingId(res);
              if (trackingId) {
                assignAcceptanceTrackingId.value = trackingId;
              }

              if (res && hasPendingDocs(res)) {
                console.log("Onboarding documents are pending. Triggering banner and checklist.", res);
                const rawDocs = extractRawDocs(res);
                pendingDocumentList.value = normalizeDocuments(rawDocs, res);
                pendingDocumentBannerSuccess.value = false;
                pendingDocumentBannerMessage.value = res.message || "You can't accept this shift yet. Required onboarding documents are still pending.";
                pendingDocumentBanner.value = true;
                dialogVisible.value = true;
                if (pendingDocumentBannerTimer) clearTimeout(pendingDocumentBannerTimer);
                pendingDocumentBannerTimer = setTimeout(() => {
                  pendingDocumentBanner.value = false;
                }, 30000);
                return;
              }

              if (res && res.success === false) {
                  ElMessage({ type: "error", message: res.message });
                  return;
              }

              pendingDocumentBannerSuccess.value = true;
              pendingDocumentBannerMessage.value = "Thank You! Your booking has been confirmed.";
              pendingDocumentBanner.value = true;
              if (pendingDocumentBannerTimer) clearTimeout(pendingDocumentBannerTimer);
              pendingDocumentBannerTimer = setTimeout(() => {
                pendingDocumentBanner.value = false;
              }, 30000);

              setTimeout(() => {
                $router.push({
                  name: "search",
                });
                if (!job.value.collaboratedBefore)
                  $router.push({
                    name: "chat_message",
                    params: {
                      chatId: `${job.value.pharmacyId}.${userData.id}`,
                      firstCollaborate: true,
                    },
                  });
              }, 2000);
            } catch (error) {
              console.error("SAVE_JOB_SHIFTS_LIST error caught:", error);
              const trackingId = extractAcceptanceTrackingId(error);
              if (trackingId) {
                assignAcceptanceTrackingId.value = trackingId;
              }
              if (error && hasPendingDocs(error)) {
                console.log("Onboarding documents are pending (from catch block). Triggering banner and checklist.", error);
                const rawDocs = extractRawDocs(error);
                pendingDocumentList.value = normalizeDocuments(rawDocs, error);
                pendingDocumentBannerSuccess.value = false;
                pendingDocumentBannerMessage.value = error.message || "You can't accept this shift yet. Required onboarding documents are still pending.";
                pendingDocumentBanner.value = true;
                dialogVisible.value = true;
                if (pendingDocumentBannerTimer) clearTimeout(pendingDocumentBannerTimer);
                pendingDocumentBannerTimer = setTimeout(() => {
                  pendingDocumentBanner.value = false;
                }, 30000);
                return;
              }
                let errorMessage = [];
                shifts.value.filter((shift) => {
                  let errorsArray = error && error.errors && error.errors.some((element) => {
                    if (element.id == shift.id) {
                      errorMessage.push({
                        date: shift.date,
                        message: element.message,
                      });
                      return true;
                    }
                  });
                  if (!errorsArray) errorMessage.push(null);
                });
                console.log(errorMessage);
                formsData.dayForm.jobShifts.errors = errorMessage;
                checkFormValidation("dayForm", true);
              }
            })();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      };
      onBeforeMount(async () => {
        console.log("iam urgent from view on beforemount");
        return new Promise((resolve) => {
          $store
            .dispatch("GET_JOB_URGENT_INFO", {
              jobId: route.params.jobId,
              params: {
                with: "shift_availability_stats,pharmacy,pharmacy.settings,pharmacy.address,shifts,shifts.abilities,settings",
              },
            })
            .then((response) => {
              let jobFetchResult = response.data;
              
              console.log("consoleeeeee",jobFetchResult);
              if (jobFetchResult.blacklistedByPharmacy) {
                goToSearch();
              }
              job.value = jobFetchResult;
              job.value.distance = jobFetchResult.distance;
              job.value.applyJob = jobFetchResult.applyJob;

              if (hasPendingDocs(jobFetchResult)) {
                const trackingId = extractAcceptanceTrackingId(jobFetchResult);
                if (trackingId) {
                  assignAcceptanceTrackingId.value = trackingId;
                }
                const rawDocs = extractRawDocs(jobFetchResult);
                pendingDocumentList.value = normalizeDocuments(rawDocs, jobFetchResult);
              }

              shifts.value = jobFetchResult.shifts;
              shifts.value.forEach((shift) => {
                moment().diff(
                  moment(
                    shift.date + " " + shift.startTime,
                    "YYYY/MM/DD HH:mm:ss"
                  ),
                  "minutes"
                ) <= 0
                  ? (shift.disabled = false)
                  : (() => {
                      shift.disabled = true;
                      shift.checkboxValue = false;
                    })();
  
                if (shift.userId) {
                  shift.disabled = true;
                  shift.checkboxValue = false;
                }
  
                if (shift.abilities) {
                  const isAssignAvailable = shift.abilities["assign"] == true;
  
                  shift.disabled = isAssignAvailable ? false : true;
                  shift.checkboxValue = isAssignAvailable ? true : false;
                }
  
                if (shift.checkboxValue == undefined) {
                  shift.checkboxValue = true;
                }
              });
              formsData.dayForm.jobShifts.value = shifts.value;
              resolve(response);
            });
        });
      });
      // let jobFetchResult = await $store.dispatch("GET_JOB_INFO", {
      //     jobId: job.value.id,
      //     params: {
      //       with: "shift_availability_stats,pharmacy,pharmacy.settings,pharmacy.address,shifts,shifts.abilities,settings",
      //     }
      // })
      // console.log('FETCH RESULT', jobFetchResult)
      // job.value.distance = jobFetchResult.data.distance
      // shifts.value =  job.value.shifts
      // console.log('JOB', job)
      // console.log('SHIFTS', shifts.value)
  
      onMounted(() => {
        setPageClassGlobal("global_job_book_page");
        setFormRefs();
        checkFormValidation("dayForm", true);
      });
  
      const formatHourlyRate = (regularRate, weekendRate) => {
        let formattedString = "";
  
        formattedString += regularRate ? "$" + regularRate : "";
        formattedString += regularRate && weekendRate ? " - " : "";
        formattedString += weekendRate ? "$" + weekendRate : "";
  
        return formattedString;
      };
  
      const handleChange = (e) => {
        e.stoppropagation();
      };
      const confirmedHours = (confirmedHours, startTime, endTime) => {
        let hours = 0;
        if (confirmedHours == 0 || confirmedHours == null) {
          const start = moment(startTime, "HH:mm:ss");
          const end = moment(endTime, "HH:mm:ss");
  
          hours = timeDiff(start, end);
        } else {
          const string = String(confirmedHours);
          const numHours = string.split(".")[0];
          let minutes = string.split(".")[1];
  
          if (!minutes) {
            const time = numHours + ":" + "00";
            hours = String(time);
          } else {
            minutes = Number.parseFloat(`0.${minutes}`) * 60;
            hours = numHours + ":" + minutes.toFixed(0);
          }
        }
  
        return hours;
      };
      const Sum = (shift) => {
        // function add(accumulator, a) {
        //   // eslint-disable-line no-unused-vars
  
        //   return +accumulator + a;
        // }
  
        let Sum;
        let confirmedHoursVal;
        let payRate;
        let travelCompensation = 0;
        const globalTravelCompensationValue =
          process.env.VUE_APP_TRAVEL_COMPENSATION;
  
        if (userRole === "locum") {
          if (shift.locum == null && shift.payRateExecSuper == null) {
            payRate = shift.recommendedRate;
          } else {
            payRate = shift.payRateExecSuper;
          }
        } else {
          payRate = shift.payRateExecSuper;
        }
  
        if (shift.confirmedHours == 0 || shift.confirmedHours == null) {
          const start = moment(shift.startTime, "HH:mm:ss");
          const end = moment(shift.endTime, "HH:mm:ss");
  
          confirmedHoursVal = timeDiffAsDecimal(start, end);
        } else {
          confirmedHoursVal = shift.confirmedHours;
        }
  
  
        let jobDistance = shift.distance ? shift.distance : null;
  
        if (jobDistance === null && job.value.distance) {
          jobDistance = job.value.distance;
        }
  
        let distance = jobDistance;
  
        
            if (job.value.settings.payingForTravel == 1) {
              if (distance * 2 > 50) {
                travelCompensation =
                  (distance * 2 - 50) * globalTravelCompensationValue;
              } else {
                // travelCompensation = shift.travelCompensation;
                travelCompensation = 0;
              }
            } else if (job.value.settings.payingForTravel == 2) {
              travelCompensation = distance * 2 * globalTravelCompensationValue;
            }
          
  
        // if (!shift.travelCompensation) {
        
        //   if (jobDistance) {
           
  
        //     if (job.value.settings.payingForTravel == 1) {
        //       if (distance * 2 > 50) {
        //         travelCompensation =
        //           (distance * 2 - 50) * globalTravelCompensationValue;
        //       } else {
        //         // travelCompensation = shift.travelCompensation;
        //         travelCompensation = 0;
        //       }
        //     } else if (job.value.settings.payingForTravel == 2) {
        //       travelCompensation = distance * 2 * globalTravelCompensationValue;
        //     }
        //   }
        // } else {
        //   if (job.value.settings.payingForTravel == 1) {
        //   if (distance * 2 > 50) {
        //         travelCompensation =
        //           (distance * 2 - 50) * globalTravelCompensationValue;
        //       } else {
        //         travelCompensation = 0;
        //       }
        //        } else if (job.value.settings.payingForTravel == 2) {
        //       travelCompensation = distance * 2 * globalTravelCompensationValue;
        //     }
        // }
  
        if (!job.value.settings.payingForTravel) {
          travelCompensation = 0;
        }
        Sum = payRate * confirmedHoursVal + travelCompensation;
        if (Sum != 0) {
          Sum = new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(Sum);
        } else {
          Sum = "-";
        }
        return Sum;
      };
  
      const Rate = (shift) => {
        if (userRole === "locum") {
          if (shift.locum == null && shift.payRateExecSuper == null) {
            return Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(shift.recommendedRate);
          } else {
            return Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(shift.payRateExecSuper);
          }
        }
      };
  
      const distance = (job, shift) => {
        let result;
        const globalTravelCompensationValue =
          process.env.VUE_APP_TRAVEL_COMPENSATION;
  
        if (!shift.distance && !job.distance) {
          result = "-";
        } else {
          let distance;
          distance = shift.historyDistance ? shift.historyDistance : job.distance;
          if (job.settings.payingForTravel == 1) {
            if (distance * 2 > 50) {
              const result1 = (distance * 2 - 50) * globalTravelCompensationValue;
              result = new Intl.NumberFormat("en-AU", {
                style: "currency",
                currency: "AUD",
              }).format(result1);
            } else {
              result = "-";
            }
          } else if (job.settings.payingForTravel == 2) {
            result = new Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(distance * 2 * globalTravelCompensationValue);
          }
        }
  
        return result;
      };
      const share = () => {
        const link = currentUrl + "job-preview/" + job.value.id;
        const el = document.createElement("textarea");
        el.value = link;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        ElMessageBox.alert("Link to current job copied to clipboard", "Thanks", {
          type: "success",
          showCancelButton: false,
          confirmButtonText: "Close",
          callback: () => {
            console.log("btn click");
          },
        });
      };
      const showShiftInformation = (shift) => {
        if (!shift.userId) return true;
        if (shift.userId === userData.id) return true;
        return false;
      };
  
      const travelCompensationCount = (job, shift) => {
        if (
          job.settings.payingForTravel === 0 &&
          !shift.adminTravelCompensation
        ) {
          return "-";
        }
        if (job.settings.payingForTravel === 0 && shift.adminTravelCompensation) {
          return `$${shift.adminTravelCompensation}`;
        } else {
          return distance(job, shift);
        }
      };
      const {
        checkFormValidation,
        setFormValidation,
        setFormRefs,
        formsData,
        formsRefs,
      } = formHooks(formsDataArray);
  
      return {
        travelCompensationCount,
        showShiftInformation,
        formatHourlyRate,
        formsData,
        handleChange,
        checkFormValidation,
        setFormValidation,
        goBack,
        goNext,
        submit,
        job,
        shifts,
        checkJobDateStart,
        checkboxValueChange,
        userInfoModalOpen,
        userInfoModal,
        Sum,
        confirmedHours,
        Rate,
        distance,
        share,
        dialogVisible,
        close,
        isAustralia,
        message,
        applyShift,
        pendingDocumentBanner,
        pendingDocumentBannerSuccess,
        pendingDocumentBannerMessage,
        pendingDocumentList,
        showDocReviewModal,
        selectedDocForReview,
        isAcknowledgingDoc,
        areAllRequiredDocsAccepted,
        handleDocItemClick,
        confirmAcknowledgeDoc,
        isImageDoc,
        isPdfDoc,
        downloadDoc,
        isDownloadingDoc,
        assignAcceptanceTrackingId,
      };
    },
  };
  </script>

<style scoped>
.premium-error-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: #fef2f2;
  border: 1px solid #fee2e2;
  border-radius: 8px;
  padding: 12px 16px;
  margin: 0 0 16px 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.premium-error-banner .premium-banner__icon {
  color: #ef4444;
  font-size: 20px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.premium-error-banner .premium-banner__text {
  color: #991b1b;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  text-align: left;
}

.premium-success-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: #f0fdf4;
  border: 1px solid #dcfce7;
  border-radius: 8px;
  padding: 12px 16px;
  margin: 0 0 16px 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.premium-success-banner .premium-banner__icon {
  color: #16a34a;
  font-size: 20px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.premium-success-banner .premium-banner__text {
  color: #166534;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  text-align: left;
}
.pending-banner-fade-enter-active,
.pending-banner-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.pending-banner-fade-enter-from,
.pending-banner-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

/* Onboarding Documents Checklist Styles */
.pending-documents-card {
  background: #f8fafc;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 18px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04);
}

.pending-documents-header {
  margin-bottom: 12px;
  text-align: left;
}

.pending-documents-title {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 6px;
}

.pending-documents-subtitle {
  font-size: 12.5px;
  color: #64748b;
  margin-top: 3px;
  line-height: 1.35;
}

.pending-documents-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pending-doc-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 14px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  user-select: none;
}

.pending-doc-item:hover {
  border-color: #3b82f6;
  box-shadow: 0 3px 8px rgba(59, 130, 246, 0.12);
  transform: translateY(-1px);
}

.pending-doc-item.is-acknowledged {
  background: #f0fdf4;
  border-color: #86efac;
}

.pending-doc-checkbox-wrapper {
  margin-top: 2px;
  display: flex;
  align-items: center;
}

.pending-documents-card .el-checkbox,
.pending-doc-checkbox-wrapper .el-checkbox {
  display: inline-flex !important;
  align-items: center !important;
  border: none !important;
  border-radius: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  position: static !important;
  height: auto !important;
  width: auto !important;
  background: transparent !important;
}

.pending-documents-card .el-checkbox .el-checkbox__input,
.pending-doc-checkbox-wrapper .el-checkbox .el-checkbox__input {
  display: inline-flex !important;
  position: static !important;
  align-items: center !important;
  justify-content: center !important;
}

.pending-documents-card .el-checkbox .el-checkbox__inner,
.pending-doc-checkbox-wrapper .el-checkbox .el-checkbox__inner {
  width: 18px !important;
  height: 18px !important;
  border-radius: 4px !important;
  margin-top: 0 !important;
  border: 1.5px solid #cbd5e1 !important;
  background-color: #ffffff !important;
  transition: all 0.15s ease-in-out !important;
}

.pending-documents-card .el-checkbox:hover .el-checkbox__inner,
.pending-doc-checkbox-wrapper .el-checkbox:hover .el-checkbox__inner {
  border-color: #3b82f6 !important;
}

.pending-documents-card .el-checkbox.is-checked .el-checkbox__inner,
.pending-doc-checkbox-wrapper .el-checkbox.is-checked .el-checkbox__inner,
.pending-documents-card .el-checkbox.is-disabled.is-checked .el-checkbox__inner,
.pending-doc-checkbox-wrapper .el-checkbox.is-disabled.is-checked .el-checkbox__inner {
  background-color: #22c55e !important;
  border-color: #22c55e !important;
}

.pending-documents-card .el-checkbox .el-checkbox__inner::after,
.pending-doc-checkbox-wrapper .el-checkbox .el-checkbox__inner::after,
.pending-documents-card .el-checkbox.is-disabled .el-checkbox__inner::after,
.pending-doc-checkbox-wrapper .el-checkbox.is-disabled .el-checkbox__inner::after {
  border-color: #ffffff !important;
  height: 9px !important;
  width: 4px !important;
  left: 5px !important;
  top: 1px !important;
}

.pending-documents-card .el-checkbox .el-checkbox__label,
.pending-doc-checkbox-wrapper .el-checkbox .el-checkbox__label {
  display: none !important;
  padding-left: 0 !important;
  width: auto !important;
}

.pending-doc-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
}

.pending-doc-name-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.pending-doc-name {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.doc-badge-required {
  background: #fee2e2;
  color: #dc2626;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 9999px;
  letter-spacing: 0.2px;
}

.doc-badge-accepted {
  background: #dcfce7;
  color: #16a34a;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.pending-doc-action-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}

.doc-action-hint {
  font-size: 12px;
  color: #3b82f6;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.doc-preview-link {
  font-size: 12px;
  color: #2563eb;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  text-decoration: underline;
  cursor: pointer;
}

.doc-preview-link:hover {
  color: #1d4ed8;
}

/* Document Review Modal Dialog Styles */
:deep(.doc-review-dialog) {
  border-radius: 16px;
  overflow: hidden;
  max-width: 680px;
}

.doc-modal-content {
  text-align: left;
}

.doc-modal-header-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 14px;
}

.doc-modal-title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.doc-modal-doc-title {
  font-size: 17px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  display: flex;
  align-items: center;
}

.doc-modal-actions-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.btn-modal-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  font-size: 12.5px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
}

.btn-modal-action.btn-open {
  background: #eff6ff;
  color: #2563eb;
  border: 1px solid #bfdbfe;
}

.btn-modal-action.btn-open:hover {
  background: #dbeafe;
  color: #1d4ed8;
}

.btn-modal-action.btn-download {
  background: #f0fdf4;
  color: #16a34a;
  border: 1px solid #bbf7d0;
}

.btn-modal-action.btn-download:hover:not(:disabled) {
  background: #dcfce7;
  color: #15803d;
}

.btn-modal-action.btn-download:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Document Inline Preview */
.doc-inline-preview-wrapper {
  margin: 12px 0;
}

.doc-preview-container {
  width: 100%;
  border-radius: 10px;
  background: #f8fafc;
  border: 1.5px solid #cbd5e1;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.doc-preview-image-box {
  max-height: 440px;
  padding: 12px;
  background: #0f172a;
}

.doc-preview-image {
  max-width: 100%;
  max-height: 410px;
  object-fit: contain;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

.doc-preview-frame-box {
  height: 420px;
}

.doc-preview-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.doc-modal-acknowledgement-box {
  background: #f8fafc;
  border: 1px dashed #94a3b8;
  border-radius: 8px;
  padding: 12px;
  margin-top: 14px;
}

.ack-note {
  font-size: 12px;
  color: #334155;
  line-height: 1.4;
}

.flex-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
  
